import React from 'react';
import Icon from '../openplay/OpenPlayIcon';
import EventCard from '../../pages/interactive-event-map/components/EventCard';

const EventInfoModal = ({ isOpen, event, fallbackEventImage, onClose, onApply, onViewDetails, onShowImage }) => {
  if (!isOpen || !event) return null;

  const urls = [event?.coverImageUrl, ...(Array.isArray(event?.imageUrls) ? event.imageUrls : [])]
    .map((u) => String(u || '').trim())
    .filter(Boolean);
  const uniqueUrls = [...new Set(urls)];
  const hasImages = uniqueUrls.length > 0;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center overflow-y-auto px-4 pt-[calc(1rem+env(safe-area-inset-top)+42px)] pb-[calc(1rem+env(safe-area-inset-bottom)+42px)] md:p-6">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />

      <div className="relative w-full max-w-md max-h-[calc(100vh-2rem-env(safe-area-inset-top)-env(safe-area-inset-bottom)-84px)] bg-card rounded-2xl border border-border shadow-elevation-3 overflow-hidden flex flex-col">
        <div className="flex items-center justify-between px-4 py-3 border-b border-border shrink-0">
          <p className="text-sm font-semibold text-foreground">이벤트 정보</p>
          <button
            type="button"
            className="w-10 h-10 rounded-lg border border-border bg-background hover:bg-muted transition-smooth flex items-center justify-center text-muted-foreground hover:text-foreground"
            aria-label="닫기"
            onClick={onClose}
          >
            <Icon name="XMarkIcon" size={20} />
          </button>
        </div>

        <div className="flex-1 min-h-0 overflow-y-auto p-4 space-y-3">
          <EventCard
            event={{
              ...(event || {}),
              coverImageUrl: String(event?.coverImageUrl || '').trim() || fallbackEventImage,
            }}
            onApply={onApply}
            onViewDetails={onViewDetails}
            onShowImage={hasImages ? () => onShowImage?.(0) : undefined}
            imageCount={hasImages ? uniqueUrls.length : undefined}
            variant="modal"
          />
        </div>
      </div>
    </div>
  );
};

export default EventInfoModal;
